import { render } from "./DownloadSvgIcon.vue?vue&type=template&id=7c5788d2"
import script from "./DownloadSvgIcon.vue?vue&type=script&lang=js"
export * from "./DownloadSvgIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__